const SimpleLightbox = require('simple-lightbox');

let lightbox = null;

function showLightbox(e) {
    e.preventDefault();
    e.stopPropagation();

    if (lightbox !== null) lightbox.destroy();

    let content = document.querySelector('.js-mobile-breadcrumbs-content');
    if (e.currentTarget.dataset.jsBreadcrumbsHook != null) {
        content = document.querySelector(`.js-mobile-breadcrumbs-content[data-js-breadcrumbs-hook="${e.currentTarget.dataset.jsBreadcrumbsHook}"]`);
    }
    content = content.cloneNode(true); // prevent Lightbox interferring with real node
    content.style.pointerEvents = 'none';
    setTimeout(() => {
        content.style.pointerEvents = 'all';
    }, 250);

    lightbox = SimpleLightbox.open({
        content,
        elementClass: 'breadcrumbs-lightbox',
        closeBtnClass: 'u-hidden',
    });
}

document.querySelectorAll('.js-mobile-breadcrumbs').forEach((btn) => {
    btn.addEventListener('click', showLightbox);
    btn.addEventListener('tap', showLightbox);
});
